type CookieOptions = {
  domain?: string
  days?: number
}

export const getCookie = (name: string): string | null => {
  if (typeof document === "undefined") return null
  const encodedName = `${encodeURIComponent(name)}=`
  const item = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(encodedName) || part.startsWith(`${name}=`))
  if (!item) return null
  return decodeURIComponent(item.slice(item.indexOf("=") + 1))
}

export const setCookie = (name: string, value: string, options: CookieOptions = {}): void => {
  if (typeof document === "undefined") return
  const parts = [`${encodeURIComponent(name)}=${encodeURIComponent(value)}`, "path=/", "sameSite=Lax"]

  if (options.domain && canUseCookieDomain(options.domain)) parts.push(`domain=${options.domain}`)
  if (options.days) {
    const expires = new Date(Date.now() + options.days * 24 * 60 * 60 * 1000)
    parts.push(`expires=${expires.toUTCString()}`)
  }

  document.cookie = parts.join(";")
}

export const deleteCookie = (name: string, domain?: string): void => {
  if (typeof document === "undefined") return
  const expire = `${encodeURIComponent(name)}=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;sameSite=Lax`
  document.cookie = expire
  if (domain && canUseCookieDomain(domain)) {
    document.cookie = `${expire};domain=${domain}`
  }
}

export const clearAuthCookies = (cookieName: string, temporaryCookieName: string, domain?: string): void => {
  deleteCookie(cookieName, domain)
  deleteCookie(temporaryCookieName, domain)
}

export const canUseCookieDomain = (domain?: string): boolean => {
  if (!domain || typeof window === "undefined") return false
  const host = window.location.hostname.toLowerCase()
  const normalized = domain.replace(/^\./, "").toLowerCase()
  return host === normalized || host.endsWith(`.${normalized}`)
}
